import { environment } from 'src/environments/environment';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
// [[PrimeNg]]
import { MessageService } from 'primeng/api';
// [[Providers]]
import { CustomerUserService } from 'src/project/services/panel/client/marketplace/customer/user/user.service';
import { CollectiveMarketplaceService } from '~services/collective/client/marketplace/marketplace.service';
import { CollectiveMarketplaceCartService } from '~services/collective/client/marketplace/cart/cart.service';
import { CollectiveMarketplaceCoreVisualBannerService } from '~services/collective/client/marketplace/core/visual/banner/banner.service';

import { ClientMarketplaceCartService } from '~services/panel/client/marketplace/cart/cart.service';
import { CustomerAddressService } from '~services/panel/client/marketplace/customer/localization/address.service';
import { ClientMarketplaceCoreProductService } from '~services/collective/client/marketplace/core/product/product.service';
import { ClientMarketplaceCartProductService } from '~services/collective/client/marketplace/cart/product/product.service';
import { ClientMarketplaceCoreConfigurationPaymentService } from '~services/collective/client/marketplace/core/configuration/payment/payment.service';
import { CustomerFinancialPaymentMethodCreditcardService } from '~services/panel/client/marketplace/customer/financial/payment/method/creditcard.service';
import { CollectiveMarketplaceCoreSubscriptionService } from '~services/collective/client/marketplace/core/subscription/subscription.service';
// ]
// [[Interfaces/Models do Componente]]

// ]
@Component({
  selector: 'app',
  templateUrl: './component.html',
  styleUrls: ['./component.scss'],
})
export class CheckoutViewComponent implements OnInit {
  /**
   * Base de uso em Component
   */
  public environment = environment;
  messageProcess = false;
  messageIsError: any;
  profile: any;
  marketplace: any = null;
  cart: any = null;
  banners: any = null;
  banners_fnc_cta: any = null;
  displayDeliveryMethodModal: boolean;
  displayCreateCreditCardModal: boolean;
  displaySubscriptionModal: boolean;

  creditcard: any = {
    brand: '',
    number: '',
    holder_name: '',
    expiry_year: new Date().getFullYear(),
    expiry_month: ('0' + (new Date().getMonth() + 1)).slice(-2),
    cvv: '',
    creditcard_funding_type: 'credit',
    creditcard_status: 'active',
  };

  transaction: any = {
    client_marketplace_customer_payment_method_creditcard_id: null,
    gateway_installments: 1,
  };

  y = () => {
    var min = new Date().getFullYear();
    var max = min + 12;
    var years = [];

    for (var i = min; i <= max; i++) {
      years.push(i);
    }
    return years;
  };

  m = () => {
    return Array.from({ length: 12 }, (_, i) => i + 1);
  };

  constructor(
    /**
     * Serviços da Aplicação
     */
    private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    /**
     * PrimeNg
     */
    private messageService: MessageService,
    /**
     * Base de uso em Component
     */
    private userService: CustomerUserService,
    private collectiveMarketplaceService: CollectiveMarketplaceService,
    private collectiveMarketplaceCartService: CollectiveMarketplaceCartService,
    private collectiveMarketplaceCoreVisualBannerService: CollectiveMarketplaceCoreVisualBannerService,
    /**
     * Services
     */
    private clientMarketplaceCartService: ClientMarketplaceCartService,
    private customerAddressService: CustomerAddressService,
    private clientMarketplaceCoreProductService: ClientMarketplaceCoreProductService,
    private clientMarketplaceCartProductService: ClientMarketplaceCartProductService,
    private clientMarketplaceCoreConfigurationPaymentService: ClientMarketplaceCoreConfigurationPaymentService,
    private customerFinancialPaymentMethodCreditcardService: CustomerFinancialPaymentMethodCreditcardService,
    private collectiveMarketplaceCoreSubscriptionService: CollectiveMarketplaceCoreSubscriptionService
  ) {}

  /**
   * on init
   */
  ngOnInit() {
    this.ipBuildEcommerceDependencies();
    this.collectiveMarketplaceCartServiceShow();
  }

  /**
   * build ecommerce dependencies
   */
  ipBuildEcommerceDependencies() {
    /**
     * Base
     *
     * Request da base de uso.
     */
    // PROFILE
    this.userService.getUser().subscribe((Profile: any) => {
      if (Profile != null) {
        if (JSON.parse(Profile) != null) {
          this.profile = JSON.parse(Profile);
        }
      }
    });
    // MARKETPLACE
    this.collectiveMarketplaceService.getMarketplace().subscribe((Marketplace: any) => {
      if (Marketplace != null) {
        if (JSON.parse(Marketplace) != null) {
          this.marketplace = JSON.parse(Marketplace);
          /**
           *
           * CONFIGURAÇÕES ADICIONAIS DESTE `COMPONENTE`
           *
           */
          // SEO
          this.titleService.setTitle(this.marketplace.name);
        }
      }
    });
    // CART
    // this.collectiveMarketplaceCartService.getCart().subscribe((Cart: any) => {
    //   if (Cart != null) {
    //     if (JSON.parse(Cart) != null) {
    //       this.cart = JSON.parse(Cart);
    //       /**
    //        *
    //        * CONFIGURAÇÕES ADICIONAIS DESTE `COMPONENTE`
    //        *
    //        */
    //       this.collectiveMarketplaceCartServiceShow();
    //     }
    //   }
    // });
    // BANNERS
    this.banners_fnc_cta = function (banner: any) {
      if (banner.url != '') {
        document.location = banner.url;
      }
      return false;
    };
    this.collectiveMarketplaceCoreVisualBannerService.getBanners().subscribe((Data: any) => {
      if (Data != null) {
        if (JSON.parse(Data) != null) {
          this.banners = JSON.parse(Data);
        }
      }
    });
  }

  /**
   * after view init
   */
  ngAfterViewInit() {}

  /**
   * on destroy
   */
  ngOnDestroy() {}

  /**
   * Collectives marketplace cart service show
   */
  collectiveMarketplaceCartServiceShow(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      const uid = params['uid'];
      const one_click_buy = params['one_click_buy'];
      /* If the client_marketplace_cart_uid is undefined, redirect to the checkout page. */
      if (typeof uid == 'undefined') {
        document.location.href = '/p/checkout?uid=' + this.cart.client_marketplace_cart_uid;
      }
      /* The code is responsible for retrieving the cart from the server, and if there are no
      products in the cart, it redirects to the cart page. */
      const _ = this.collectiveMarketplaceCartService.view({ client_marketplace_cart_uid: uid });
      if (_ !== null) {
        _.subscribe(
          (response: any) => {
            this.cart = response.data;
            /* Checking if the cart is not in the shopping status, if it is not, it will redirect to
            the order page. */
            if (this.cart.client_marketplace_cart_status != 'shopping') {
              document.location.href = '/a/order';
            } else {
              /*
                Checkout sem Produtos??!
              */
              if (this.cart.products.length == 0) {
                document.location.href = '/p/cart';
              } else {
                /**
                 *
                 * CONFIGURAÇÕES ADICIONAIS DESTE `COMPONENTE`
                 *
                 */
                // Caso já tenha uma definição de qual Recorrência utilizar.
                this.subscriptionExpectedOnThisOrder.client_marketplace_core_subscription_id = this.cart.client_marketplace_core_subscription_id;

                this.customerAddressServiceIndex();
                this.clientMarketplaceCoreConfigurationPaymentServiceCalcInstallments();
                this.customerFinancialPaymentMethodCreditcardServiceIndex();
                this.collectiveMarketplaceCoreSubscriptionServiceIndex();

                if (typeof one_click_buy != 'undefined') {
                  this.collectiveMarketplaceCartServiceApplyOneClickBuyWhenIsPossible();
                }
              }
            }
          },
          (err) => {
            if (err.error.errors) {
              for (let error in err.error.errors) {
                this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
                this.messageProcess = false;
                this.messageIsError = this.collectiveMarketplaceCartService.error.throw(error);
              }
            }
          }
        );
      }
    });
  }

  address_delivery_applied: any;
  price_delivery: any;
  // @ViewChild("modalDeliveryMethod", { static: false }) modalDeliveryMethod: ModalDirective;
  /**
   * Clients marketplace cart service price delivery
   * @param address
   */
  collectiveMarketplaceCartServicePriceDelivery(address: any) {
    this.address_delivery_applied = address;

    var _ = this.collectiveMarketplaceCartService.price_delivery({ client_marketplace_cart_uid: this.cart.client_marketplace_cart_uid, zipcode: address.zipcode });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.price_delivery = response.data;
          this.displayDeliveryMethodModal = true;
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.collectiveMarketplaceCartService.error.throw(error);
            }
          }
        }
      );
    }
  }

  calc_installments: any;
  /**
   * Clients marketplace core configuration payment service calc installments
   */
  clientMarketplaceCoreConfigurationPaymentServiceCalcInstallments() {
    var _ = this.clientMarketplaceCoreConfigurationPaymentService.calc_installments({
      amount: this.cart.price_accumulated,
    });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.calc_installments = response.data;
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.collectiveMarketplaceCartService.error.throw(error);
            }
          }
        }
      );
    }
  }

  /**
   * Clients marketplace cart service delivery method
   * @param delivery
   */
  collectiveMarketplaceCartServiceApplyDeliveryMethod(delivery: any) {
    var _ = this.collectiveMarketplaceCartService.apply_delivery_method({
      client_marketplace_cart_uid: this.cart.client_marketplace_cart_uid,
      client_marketplace_customer_charging_address_id: this.address_delivery_applied.id,
      client_marketplace_core_delivery_id: delivery.id,
      zipcode: this.address_delivery_applied.zipcode,
    });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.cart = response.data;
          this.price_delivery = {};
          this.displayDeliveryMethodModal = false;
          // COMO O VALOR SERÁ ATUALIZADO, É PRECISO RECALCULAR O VALOR DE PARCELAMENTO.
          this.clientMarketplaceCoreConfigurationPaymentServiceCalcInstallments();
          /* The above code is a TypeScript function that is part of the Collective Marketplace Core
          subscription service. */
          this.collectiveMarketplaceCoreSubscriptionServiceIndex();
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.collectiveMarketplaceCartService.error.throw(error);
            }
          }
        }
      );
    }
  }

  /**
   * Clients marketplace cart service address empty
   */
  collectiveMarketplaceCartServiceAddressEmpty() {
    var _ = this.collectiveMarketplaceCartService.empty_cart_address({
      client_marketplace_cart_uid: this.cart.client_marketplace_cart_uid,
    });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.cart = response.data;
          /* The above code is a TypeScript function that is part of the Collective Marketplace Core
          subscription service. */
          this.collectiveMarketplaceCoreSubscriptionServiceIndex();
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.collectiveMarketplaceCartService.error.throw(error);
            }
          }
        }
      );
    }
  }

  /**
   * Collectives marketplace cart service subscription empty
   */
  collectiveMarketplaceCartServiceSubscriptionEmpty() {
    var _ = this.collectiveMarketplaceCartService.empty_cart_subscription({
      client_marketplace_cart_uid: this.cart.client_marketplace_cart_uid,
    });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.cart = response.data;
          this.subscriptionExpectedOnThisOrder.client_marketplace_core_subscription_id = this.cart.client_marketplace_core_subscription_id;
          /* The above code is a TypeScript function that is part of the Collective Marketplace Core
          subscription service. */
          this.collectiveMarketplaceCoreSubscriptionServiceIndex();
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.collectiveMarketplaceCartService.error.throw(error);
            }
          }
        }
      );
    }
  }

  /**
   * Collectives marketplace cart service voucher empty
   */
  collectiveMarketplaceCartServiceVoucherEmpty() {
    var _ = this.collectiveMarketplaceCartService.empty_cart_voucher({
      client_marketplace_cart_uid: this.cart.client_marketplace_cart_uid,
    });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          var cart = response.data;
          this.collectiveMarketplaceCartServiceShow();
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.collectiveMarketplaceCartService.error.throw(error);
            }
          }
        }
      );
    }
  }

  /**
   * Collectives marketplace cart service apply one click buy when is possible
   */
  collectiveMarketplaceCartServiceApplyOneClickBuyWhenIsPossible() {
    var _ = this.collectiveMarketplaceCartService.apply_one_click_buy_when_is_possible({
      client_marketplace_cart_uid: this.cart.client_marketplace_cart_uid,
    });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.cart = response.data;
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.collectiveMarketplaceCartService.error.throw(error);
            }
          }
        }
      );
    }
  }

  /**
   * Clients marketplace cart service done
   */
  collectiveMarketplaceCartServiceDone() {
    this.messageProcess = true;
    /* This is setting the transaction and subscriptionExpectedOnThisOrder properties of the cart object. */
    this.cart.transaction = this.transaction;
    this.cart.subscription = this.subscriptionExpectedOnThisOrder;
    /* The client's cart is done and the user is redirected to the order success page. */
    var _ = this.clientMarketplaceCartService.done(this.cart);
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          /* This code is removing the client's cart from the local storage. */
          localStorage.removeItem('client_marketplace_cart');
          /* This code is redirecting the user to the order success page. */
          document.location.href = '/a/order/' + response.data.id + '/success';
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.clientMarketplaceCartService.error.throw(error);
            }
          }
        }
      );
    }
  }

  customer_addresses: any;
  /**
   * Customers address service index
   */
  customerAddressServiceIndex() {
    /* The code above is a simple example of how to use the index method of the
    customerAddressService. */
    var _ = this.customerAddressService.index({});
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.customer_addresses = response.data;

          if (this.customer_addresses.length == 0) {
            this.router.navigate(['/a/address']);
          }
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.customerAddressService.error.throw(error);
            }
          }
        }
      );
    }
  }

  creditcards: any;
  /**
   * Customers financial payment method creditcard service index
   */
  customerFinancialPaymentMethodCreditcardServiceIndex() {
    /* The code checks if the customer has any credit cards saved in the database. If so, it sets
    the first credit card as the default credit card. */
    var _ = this.customerFinancialPaymentMethodCreditcardService.index({});
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.creditcards = response.data.data;
          // Cartão "Padrão" para uso.
          if (this.creditcards.length > 0) {
            // SE ESTIVER LIBERADA OPÇÃO DE PAGAMENTO POR CARTÃO.
            if (this.marketplace.payment.accept_credit_card == 'yes') {
              //this.cart.payment_method = "credit_card";
              this.transaction.client_marketplace_customer_payment_method_creditcard_id = this.creditcards[0].id;
            }
          }
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.customerFinancialPaymentMethodCreditcardService.error.throw(error);
            }
          }
        }
      );
    }
  }

  // @ViewChild("modalCreditCard", { static: false }) modalCreditCard: ModalDirective;
  /**
   * Customers financial payment method creditcard service create
   */
  customerFinancialPaymentMethodCreditcardServiceCreate() {
    let _ = this.customerFinancialPaymentMethodCreditcardService.store(this.creditcard);
    if (_ !== null) {
      _.subscribe(
        () => {
          this.customerFinancialPaymentMethodCreditcardServiceIndex();
          this.cart.payment_method = 'credit_card';
          this.displayCreateCreditCardModal = false;
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.customerFinancialPaymentMethodCreditcardService.error.throw(error);
            }
          }
        }
      );
    }
  }

  subscriptionAvailable: any;
  /**
   * Collectives marketplace core subscription service index
   */
  collectiveMarketplaceCoreSubscriptionServiceIndex() {
    /* The code above is a simple example of how to use the collective marketplace core subscription
    service. */
    var _ = this.collectiveMarketplaceCoreSubscriptionService.index({
      per_page: 20,
      page: 1,
      client_marketplace_core_subscription_id: this.subscriptionExpectedOnThisOrder.client_marketplace_core_subscription_id,
      price: this.cart.price_accumulated,
      zipcode: this.cart.zipcode,
    });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.subscriptionAvailable = response.data;
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.collectiveMarketplaceCoreSubscriptionService.error.throw(error);
            }
          }
        }
      );
    }
  }

  subscription: any = {};
  subscriptionExpectedOnThisOrder: any = {
    client_marketplace_core_subscription_id: null,
    billing_cycle: 'weekly',
    billing_cycle_weekday: 'friday',
  };
  /**
   * Cannot generate summary
   * @param {any} subscription - the subscription object
   * @returns None
   */
  collectiveMarketplaceCoreSubscriptionServiceDetail(subscription: any) {
    this.subscription = subscription;
    this.displaySubscriptionModal = true;
  }

  collectiveMarketplaceSubscriptionDone() {
    this.subscriptionExpectedOnThisOrder.client_marketplace_core_subscription_id = this.subscriptionAvailable.id;
    this.collectiveMarketplaceCartServiceDone();
  }
}
